import React from 'react';
import { Button } from 'antd';
import { useFilterSortContext } from '../context/filter-sort-context';

export const SortButton = (): JSX.Element => {
  const { sortOpened, setSortOpened } = useFilterSortContext();
  return (
    <Button
      onClick={() => setSortOpened(!sortOpened)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        backgroundColor: `${sortOpened ? '#190952' : '#F7F8FA'}`,
        borderColor: '#190952',
      }}
      icon={sortOpened ? (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 9.52383L11.0476 12.653L14.0952 9.52383M8 6.47621L4.95238 3.42859M4.95238 3.42859L1.90476 6.47392M4.95238 3.42859V12.5714M11.0476 3.42859V12.5714" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 9.52383L11.0476 12.653L14.0952 9.52383M8 6.47621L4.95238 3.42859M4.95238 3.42859L1.90476 6.47392M4.95238 3.42859V12.5714M11.0476 3.42859V12.5714" stroke="#190952" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    />
  );
};
